import { ModuleWithProviders, NgModule } from "@angular/core";

import { TAutoLogoutConfig } from "@app/core/auto-logout/auto-logout.type";
import { AUTO_LOGOUT_CONFIG } from "@app/core/auto-logout/auto-logout.injection";

@NgModule()
export class AutoLogoutModule {
  static forRoot(config: TAutoLogoutConfig): ModuleWithProviders<AutoLogoutModule> {
    return {
      ngModule: AutoLogoutModule,
      providers: [
        {
          provide: AUTO_LOGOUT_CONFIG,
          useValue: config,
        }
      ]
    };
  }
}
